module.exports = __webpack_public_path__ + "static/img/logo01.8e4812b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link2/logo01.jpg
// module id = cJmz
// module chunks = 1